import { SmallText as e } from "../Typography/Typography.js";
import "../Typography/index.js";
import t from "./Banner.module.js";
import { c as n } from "react/compiler-runtime";
import r from "@jetbrains/icons/close-12px.js";
import { Button as i } from "@jetbrains/ring-ui-built/components/button/button.js";
import { ControlsHeight as a } from "@jetbrains/ring-ui-built/components/global/controls-height.js";
import o from "classnames";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
//#region src/components/Banner/Banner.tsx
function l(l) {
	let u = n(25), { children: d, type: f, action: p, className: m, onClose: h } = l, g;
	bb0: {
		if (!p) {
			g = null;
			break bb0;
		}
		if ("custom" in p) {
			g = p.custom;
			break bb0;
		}
		let e, n;
		u[0] === p ? (e = u[1], n = u[2]) : ({children: n, ...e} = p, u[0] = p, u[1] = e, u[2] = n);
		let r;
		u[3] === m ? r = u[4] : (r = o(m, t.actionButton), u[3] = m, u[4] = r);
		let c = `${l["data-test"] ?? "banner"}-action-button`, d;
		u[5] !== e || u[6] !== n || u[7] !== r || u[8] !== c ? (d = /* @__PURE__ */ s(i, {
			...e,
			primary: !0,
			height: a.S,
			className: r,
			"data-test": c,
			children: n
		}), u[5] = e, u[6] = n, u[7] = r, u[8] = c, u[9] = d) : d = u[9], g = d;
	}
	let _ = g, v = t[f], y;
	u[10] !== p || u[11] !== m || u[12] !== v ? (y = o(t.banner, v, m, { [t.bannerWithActions]: p }), u[10] = p, u[11] = m, u[12] = v, u[13] = y) : y = u[13];
	let b = l["data-test"], x;
	u[14] === d ? x = u[15] : (x = /* @__PURE__ */ s(e, {
		className: t.text,
		children: d
	}), u[14] = d, u[15] = x);
	let S;
	u[16] !== p || u[17] !== h ? (S = h && /* @__PURE__ */ s(i, {
		"aria-label": "Close",
		className: o(t.closeButton, { [t.absoluteIcon]: p }),
		iconClassName: t.closeIcon,
		onClick: h,
		icon: r
	}), u[16] = p, u[17] = h, u[18] = S) : S = u[18];
	let C;
	return u[19] !== _ || u[20] !== y || u[21] !== b || u[22] !== x || u[23] !== S ? (C = /* @__PURE__ */ c("div", {
		className: y,
		"data-test": b,
		children: [
			x,
			_,
			S
		]
	}), u[19] = _, u[20] = y, u[21] = b, u[22] = x, u[23] = S, u[24] = C) : C = u[24], C;
}
//#endregion
export { l as Banner };
